import { AddressAutocompleteResult } from '@app/infrastructure/address/model/AddressAutocompleteResult';
import { UrlBuilder } from '@app/lib/http/client/url/UrlBuilder';
import { useCallback, useState } from 'react';

export interface UseAddressAutocompleteReturnType {
    search: (query: string, country?: string) => Promise<void>;
    results: AddressAutocompleteResult[];
}

export function useAddressAutocomplete(): UseAddressAutocompleteReturnType {
    const [results, setResults] = useState<AddressAutocompleteResult[]>([]);

    const search = useCallback(async (query: string, country?: string) => {
        try {
            const response = await fetch(
                UrlBuilder.build('/api/address/autocomplete', null, null, {
                    q: query,
                    country: country?.toUpperCase(),
                }),
            );

            if (!response.ok) {
                return setResults([]);
            }

            const result = await response.json();

            setResults(result);
        } catch {
            setResults([]);
        }
    }, []);

    return {
        search,
        results,
    };
}
